/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_DamperInputs */



/**
* | output |
* | --- |
* | "Damper" |
*
* @param {Actuator_Type_DamperInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_damper = /** @type {((inputs?: Actuator_Type_DamperInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_DamperInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Damper")
	return /** @type {LocalizedString} */ ("Volet")
});